<div class="page">
    <p-tabs class="tabs" scrollable [value]="activeTab" (valueChange)="onTabChange($event)">
        <p-tablist>
            <p-tab [value]="vacanciesTab">{{ 'label.VacancyApplications' | translate }}</p-tab>
            <p-tab [value]="invitationsTab">{{ 'label.Invitations' | translate }}</p-tab>
            <p-tab [value]="cvBoxesTab">{{ 'label.CvBoxes' | translate }}</p-tab>
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel [value]="vacanciesTab">
                <app-spinner [isLoading]="vacancyApplicationIsLoading$ | async" [isFixedPosition]="false">
                    @if (activeTab === vacanciesTab) {
                        <app-jobseeker-applies-vacancy></app-jobseeker-applies-vacancy>
                    }
                </app-spinner>
            </p-tabpanel>

            <p-tabpanel [value]="invitationsTab">
                <router-outlet></router-outlet>
            </p-tabpanel>

            <p-tabpanel [value]="cvBoxesTab">
                <app-spinner [isLoading]="cvBoxApplicationIsLoading$ | async" [isFixedPosition]="false">
                    @if (activeTab === cvBoxesTab) {
                        <app-jobseeker-applies-cv-box></app-jobseeker-applies-cv-box>
                    }
                </app-spinner>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>
